<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'card1',
})
</script>
<template>
    <div v-if="data" :id="'card'+data.id">
      <contenttitle :data="data"></contenttitle>
      <a-row :gutter="[30,30]" class="margin-tb-lg text-white">
          <template v-for="(item,i) in data.child">
            <a-col v-if="(i%data.col==0&&i>0)"  :span="24"  :key="i">
              <a :href="item.url" class="content-box bg-img  flex-column align-center justify-center"  :style="{backgroundImage:'url('+addip(item.pic)+')',height:height+'px'}">
                <img :src="addip(item.icon)" />
                <h3>{{ item.name }}</h3>
              </a>
            </a-col>
            <a-col v-else  :md="getCol.md(data.col)" :sm="getCol.sm(data.col)" :lg="getCol.lg(data.col)" >
              <a :href="item.url"  class="content-box  flex bg-img flex-column align-center justify-center" :style="{backgroundImage:'url('+addip(item.pic)+')',height:height+'px'}" >
                <img :src="addip(item.icon)"  />
                <h3>{{ item.name }}</h3>
              </a>
            </a-col>
          </template>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="card1">
import {defineComponent,defineProps ,onMounted,ref} from 'vue';
import {addip,colors,getCol} from '@/utils/util'
import {ArrowRightOutlined, PropertySafetyFilled}  from '@ant-design/icons-vue'
const props=defineProps({
  data:Object
})
const height=ref<Number>(128)
onMounted(()=>{
  var dom=document.querySelector('#card'+props.data.id+' .content-box')
  height.value=dom.offsetWidth
})
</script>
<style lang="less">
.card1 {
  img{width:128px;height:128px; margin:20px;}

  .content-box:hover{
  background-position:50% 40%!important;
  -webkit-backdrop-filter:blur(10px);
  backdrop-filter: blur(10px); /* 调整数值控制模糊程度 */
  }
}
</style>
